/**
 * ApplyContainer
 * --
 */
import React from 'react';
import ApplyPresenter from './ApplyPresenter';
import { useCreateShopInformation } from 'hooks/ShopInformationHooks';
import { useUserAction, useUserStack } from 'store';
import MessageAlert from 'utils';
import { useUpdateAdmin } from 'hooks/AdminHooks';
import { LoadingPage } from 'components';
import { useNavigate } from 'react-router-dom';

const ApplyContainer = () => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();

  /* ===== PROPS ===== */
  /* ===== Store ===== */
  const userInfo = useUserStack();
  const userAction = useUserAction();

  /* ===== Mutate ===== */
  const { createShopInformation } = useCreateShopInformation();
  const { updateAdmin } = useUpdateAdmin();

  /* ===== Ref ===== */
  const nameRef = React.useRef(null);
  const contentRef = React.useRef(null);

  /* ===== STATE ===== */
  // 기본 정보
  const [inputValue, setInputValue] = React.useState({
    shop_information_name: '', // 쇼핑몰 명
    shop_information_content: '', // 쇼핑몰 설명
    shop_information_address: '', // 쇼핑몰 주소
    shop_information_address_detail: '', // 쇼핑몰 주소 상세
    application_status: 'APPLY', // 입점신청여부
    type: 'SHOP', // 타입
  });
  // 쇼핑몰 정보
  const [informationValue, setInformationValue] = React.useState({});
  // 로딩
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 쇼핑몰 정보 생성
   * --
   */
  const handleSubmit = async () => {
    // TODO: 필수 입력값 입력 여부 체크
    const { shop_information_name, shop_information_content } = inputValue;

    if (!shop_information_name) {
      MessageAlert.warning('브랜드명을 입력해주세요!');
      nameRef.current.focus();
      return;
    }

    if (!shop_information_content) {
      MessageAlert.warning('브랜드명 설명 입력해주세요!');
      contentRef.current.focus();
      return;
    }

    try {
      // NOTE: 로딩 시작
      setIsLoading(true);

      /**
       * REVIEW: 쇼핑몰 생성 프로세스
       * --
       * 쇼핑몰 생성 -> 관리자 업데이트 -> 스토어 업데이트
       */
      // NOTE: 쇼핑몰 정보 생성
      const { status: shopStatus, data: shopData } =
        await createShopInformation(inputValue);

      // NOTE: 쇼핑몰 생성 성공 처리
      if (shopStatus === 200) {
        const { shop_information_id, type, created_at, updated_at, ...d } =
          shopData;

        // NOTE: 관리자 업데이트
        const { status: adminStatus } = await updateAdmin({
          admin_id: userInfo.admin_id,
          shop_information_id: shop_information_id,
        });

        // NOTE: 관리자 업데이트 성공 처리
        if (adminStatus === 200) {
          // NOTE: 스토어 업데이트
          const newUser = {
            ...userInfo,
            ...d,
            shop_information_id,
          };

          userAction.setUser(newUser);
          navigate('/main', { replace: 'true' });
        }
        // TODO: 관리자 업데이트 실패 처리
        else {
          MessageAlert.error(
            `쇼핑몰 정보를 업데이트하는데 에러가 발생하였습니다. 관리자에게 문의해주세요.`
          );
        }
      }
      // TODO: 쇼핑몰 생성 실패 처리
      else {
        MessageAlert.error(
          `쇼핑몰 정보를 등록하는데 에러가 발생하였습니다. 관리자에게 문의해주세요.`
        );
      }
    } catch (err) {
      console.error(`[CREATE SHOP INFORMATION] ERROR: `, err);
      MessageAlert.error(`쇼핑몰 정보를 등록하는데 에러가 발생하였습니다`);
      throw err;
    } finally {
      // NOTE: 로딩 종료
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  /**
   * 데이터 바인딩 함수
   * --
   * @param {string} target
   * @param {*} value
   * @param {object} object
   * @param {*} callback
   */
  const handleChange = (t, v, o, callback = null) => {
    let newData = { ...o };

    newData[t] = v;
    const d = {
      ...newData,
    };

    callback(d);
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {isLoading && <LoadingPage text={'쇼핑몰 정보를 등록하고 있습니다.'} />}
      <ApplyPresenter
        nameRef={nameRef}
        contentRef={contentRef}
        inputValue={inputValue}
        setInputValue={setInputValue}
        informationValue={informationValue}
        setInformationValue={setInformationValue}
        onSubmit={handleSubmit}
        onChange={handleChange}
      />
    </>
  );
};

export default ApplyContainer;
